module.exports = __webpack_public_path__ + "img/ticket-2-fill.b0938722.svg";